import { FileField, FileInput, Form, useCreate, useNotify, useTranslate } from 'react-admin';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button } from '@mui/material';
import ButtonsBlock from '@/components/common/buttons-block/buttons-block';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import { useParams } from 'react-router';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { bytesToMegabytes, getFileBase64 } from '@/utils/files';
import { AVATAR_RESOURCE_SUPPORTED, FILE_MEDIA_TYPE, MEDIAS } from '@/utils/CONST';

interface Props {
    open: boolean;
    tag: string;
    onClose: any;
    refetch: any;
}

const UploadDocumentDialog = ({ open, tag, onClose, refetch }: Props) => {
    const translate = useTranslate();
    const [create, { isLoading: isLoadingCreate }] = useCreate();
    const { siteId } = useParams();
    const notify = useNotify();

    const handleSubmit = async ({ media }: any) => {
        const fileData: any = await getFileBase64(media.rawFile);

        const finalMedia = {
            mediaType: FILE_MEDIA_TYPE,
            resourceSupported: AVATAR_RESOURCE_SUPPORTED,
            fileName: media.title,
            base64data: fileData,
            resourceId: siteId,
            tags: [tag],
            customFields: {
                tags: [tag],
            },
        };

        create(
            MEDIAS,
            {
                data: finalMedia,
            },
            {
                onSuccess: () => {
                    refetch();
                    onClose();
                },
            },
        );
    };

    return (
        <DialogTemplate
            icon={<FileUploadIcon />}
            title={translate('buttons.upload_document')}
            open={open}
            onClose={onClose}
            closeButtonDisabled={isLoadingCreate}
        >
            <Form onSubmit={handleSubmit}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 2,
                    }}
                >
                    <FileInput
                        source='media'
                        label={false}
                        helperText={false}
                        maxSize={30000000}
                        sx={{
                            '& .previews': {
                                display: 'flex',
                                justifyContent: 'center',
                            },
                        }}
                        options={{
                            onDropRejected: (files: any) => {
                                console.log('files', files);
                                if (files.length > 0) {
                                    if (files[0].errors[0].code === 'file-too-large') {
                                        notify('messages.file_too_large', {
                                            type: 'warning',
                                            messageArgs: {
                                                size: bytesToMegabytes(files[0].file.size),
                                            },
                                        });
                                    }
                                }
                            },
                        }}
                    >
                        <FileField source='src' title='title' />
                    </FileInput>

                    <ButtonsBlock>
                        <Button onClick={onClose} disabled={isLoadingCreate}>
                            {translate('ra.action.cancel')}
                        </Button>

                        <LoadingButton type='submit' variant='contained' loading={isLoadingCreate}>
                            {translate('ra.action.confirm')}
                        </LoadingButton>
                    </ButtonsBlock>
                </Box>
            </Form>
        </DialogTemplate>
    );
};

export default UploadDocumentDialog;
